import React from 'react';

// Shared Viber group invite link (also used by ViberPopup)
export const VIBER_INVITE_URL =
  'https://invite.viber.com/?g2=AQAP2SKFNmnwWFYyTo8QglRVCrGwCxn5%2F3aimX7%2BTJXhQ4cJgW1zvwlpdc3KAQ%2Fm';

const ViberGlyph: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
    <circle cx="24" cy="24" r="24" fill="white" fillOpacity="0.15" />
    <path
      d="M35.2 12.8C33.4 11 28.8 8.6 24.2 8.4h-.1c-4.6.2-9.2 2.6-11 4.4-1.4 1.4-2.8 3.8-3.2 7.2-.4 3.4-.1 7.4 2.2 10.4v4.4c0 .6.4 1.2 1 1.4.2.1.4.1.6.1.4 0 .8-.2 1-.4l2.8-2.8c1.2.3 2.4.4 3.6.4h.1c4.6-.2 9.2-2.6 11-4.4 1.4-1.4 2.8-3.8 3.2-7.2.4-3.4.1-7.4-2.2-10.1zM27 19.6c.2.2.2.6 0 .8l-1.6 1.6c-.1.1-.1.2 0 .4l1.6 1.6c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-1.6-1.6c-.2-.2-.4-.2-.6 0l-1.6 1.6c-.2.2-.6.2-.8 0-.2-.2-.2-.6 0-.8l1.6-1.6c.1-.1.1-.2 0-.4l-1.6-1.6c-.2-.2-.2-.6 0-.8.2-.2.6-.2.8 0l1.6 1.6c.2.2.4.2.6 0l1.6-1.6c.2-.2.6-.2.8 0z"
      fill="white"
    />
  </svg>
);

interface ViberJoinButtonProps {
  variant?: 'hero' | 'card';
  label?: string;
  className?: string;
}

const ViberJoinButton: React.FC<ViberJoinButtonProps> = ({
  variant = 'card',
  label = 'Viber група',
  className = '',
}) => {
  const isHero = variant === 'hero';
  return (
    <a
      href={VIBER_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Присъединете се към нашата Viber група"
      className={
        'inline-flex items-center justify-center gap-2 bg-purple-600 hover:bg-purple-500 text-white transition-all duration-200 shadow-lg ' +
        (isHero
          ? 'px-8 py-4 rounded-xl font-bold text-base hover:scale-105 '
          : 'px-4 py-2.5 rounded-lg font-semibold text-sm w-full ') +
        className
      }
    >
      <ViberGlyph className={isHero ? 'h-6 w-6' : 'h-5 w-5'} />
      {label}
    </a>
  );
};

export default ViberJoinButton;
